var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 7.61,
    fill: "none",
    viewBox: "0 0 11 9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.2284 2.0445c.3621-.3621.3621-.9279 0-1.29-.362-.3394-.9278-.3394-1.2672 0L3.8017 5.9142l-2.263-2.263c-.362-.3394-.9277-.3394-1.2671 0-.3621.3621-.3621.9278 0 1.2899L3.168 7.8376c.1584.181.4073.2715.6336.2715s.4526-.0905.6336-.2715z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkbox-icon.e9c3f75a09368ab7ec02bf227fea6d8f.svg";